import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import NotFound from "../extras/NotFound";
import WithNavbar from "../extras/PrivateRouteWithNavbar"
import SellersTable from '../tables/SellersTable'
import CreateSeller from '../creation-forms/CreateSeller'
import ViewSeller from '../view-edit/ViewSeller'

export default function Sellers() {
    const match = useRouteMatch();
    return (
        <Switch>
            <WithNavbar exact path={match.path} component={SellersTable} />
            <WithNavbar path={`${match.path}/create`} component={CreateSeller} />
            <WithNavbar path={`${match.path}/view_:id`} component={ViewSeller} />
            <Route path="*" component={NotFound} />
        </Switch>
    )
}